'use client';

import { FiMoon, FiSun } from 'react-icons/fi';

import useColorScheme from '~/shared/hooks/use-color-scheme';

import './theme-switcher.scss';

const ThemeSwitcher = () => {
  const { isDarkTheme, toggleColorScheme } = useColorScheme();

  return (
    <button
      type="button"
      className="theme-switcher"
      onClick={toggleColorScheme}
      aria-label={isDarkTheme ? 'Switch to light theme' : 'Switch to dark theme'}
      title={isDarkTheme ? 'Light theme' : 'Dark theme'}
    >
      <span className="theme-switcher__track" aria-hidden="true">
        <FiSun className="theme-switcher__icon theme-switcher__icon--sun" />
        <FiMoon className="theme-switcher__icon theme-switcher__icon--moon" />
        <span className="theme-switcher__thumb">
          <FiSun className="theme-switcher__thumb-icon theme-switcher__thumb-icon--sun" />
          <FiMoon className="theme-switcher__thumb-icon theme-switcher__thumb-icon--moon" />
        </span>
      </span>
    </button>
  );
};

export default ThemeSwitcher;
